import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ProfileComponent } from './components/profile/profile.component';
import { JoinGroupComponent } from './components/join-group/join-group.component';
import { GroupComponent } from './components/groups/group-header/group.component';
import { GroupOverviewComponent } from './components/groups/group-overview.component';
import { GroupPapersComponent } from './components/groups/group-papers.component';
import { GroupReadingListDetailComponent } from './components/groups/reading-list/group-reading-list-detail.component';
import { GroupReadingListsComponent } from './components/groups/reading-list/group-reading-lists.component';
import { GroupCreateModalComponent } from './components/modals/group-create-modal/group-create-modal.component';
import { GroupInviteModalComponent } from './components/modals/group-invite-modal/group-invite-modal.component';
import { GroupEditModalComponent } from './components/modals/group-edit-modal/group-edit-modal.component';
import { ProfileEditModalComponent } from './components/modals/profile-edit-modal/profile-edit-modal.component';
import { BaseModalComponent } from './components/modals/base-modal/base-modal.component';
import { BaseAlertComponent } from './components/alerts/base-alert/base-alert.component';
import { BaseToastComponent } from './components/alerts/base-toast/base-toast.component';
import { NotificationBellComponent } from './components/header/notification-bell/notification-bell.component';
import { httpInterceptorProviders } from './interceptors';
import { ConfirmModalComponent } from './components/modals/confirm-modal/confirm-modal.component';
import { ProjectCardComponent } from './components/projects/project-card/project-card.component';
import { PasswordFormComponent } from './components/password-form/password-form.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ProjectCreateModalComponent } from './components/modals/project-create-modal/project-create-modal.component';
import { GroupHoverPopupComponent } from './components/modals/group-hover-popup/group-hover-popup.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    ProfileComponent,
    GroupInviteModalComponent,
    PasswordFormComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    GroupComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BaseModalComponent,
    BaseAlertComponent,
    BaseToastComponent,
    NotificationBellComponent,
    JoinGroupComponent,
    GroupCreateModalComponent,
    GroupEditModalComponent,
    ProfileEditModalComponent,
    ConfirmModalComponent,
    ProjectCardComponent,
    ProjectCreateModalComponent,
    GroupHoverPopupComponent,
    GroupOverviewComponent,
    GroupPapersComponent,
    GroupReadingListsComponent,
    GroupReadingListDetailComponent,
  ],
  providers: [
    httpInterceptorProviders,
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
